import { apiClient } from "../../../../services/apiClient";

export const leadTimeDashboardApi = {
  getLeadTimeDashboard: async (fileType = 'main', objectType) => {
    try {
      const response = await apiClient.post('/lead-time-dashboard', {
        file_type: fileType,
        object_type: objectType
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching lead time dashboard:', error.response || error.message || error);
      throw error;
    }
  }
};
